import { render, staticRenderFns } from "./ContactMessage.vue?vue&type=template&id=f520750c&scoped=true&"
import script from "./ContactMessage.vue?vue&type=script&lang=js&"
export * from "./ContactMessage.vue?vue&type=script&lang=js&"
import style0 from "./ContactMessage.vue?vue&type=style&index=0&id=f520750c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f520750c",
  null
  
)

export default component.exports